<template>
	<v-container
		><div>
			<v-tabs
				v-model="activeTab"
				:color="themeInputColor"
				dark
				slider-color="yellow"
				grow
			>
				<v-tab
					v-for="(tab, i) in tabs"
					:key="i"
					:href="'#tab-' + i"
					:ripple="false"
					class="px-3"
					@click="sendEvent(tab.name)"
				>
					{{ tab.name }}
				</v-tab>
			</v-tabs>
			<v-tabs-items v-model="activeTab">
				<v-tab-item value="tab-0">
					<v-card flat>
						<v-card-text>
							<v-data-table
								:items="
									keysFilteration(
										Object.keys(
											totalData.total[0] || {}
										).sort(keyA => {
											if (
												this.priorityKeys.indexOf(
													keyA
												) !== -1
											) {
												return -1;
											}
											return 1;
										}),
										['daily', 'dau']
									)
								"
								class="elevation-1"
								:hide-actions="true"
								hide-headers
							>
								<template v-slot:items="props">
									<tr>
										<td>
											{{
												convertToReadableForm(
													props.item
												)
											}}
										</td>
										<td>
											{{
												totalData.total[0][
													props.item
												] || 0
											}}
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item value="tab-1"
					><v-card flat>
						<v-card-text>
							<v-data-table
								:items="
									keysFilteration(
										Object.keys(
											totalData.endDate[0] || {}
										).sort(keyA => {
											if (
												this.priorityKeys.indexOf(
													keyA
												) !== -1
											) {
												return -1;
											}
											return 1;
										}),
										['monthly', 'mau']
									)
								"
								class="elevation-1"
								:hide-actions="true"
								hide-headers
							>
								<template v-slot:items="props">
									<tr>
										<td>
											{{
												convertToReadableForm(
													props.item
												)
											}}
										</td>
										<td>
											{{
												totalData.endDate[0][
													props.item
												] || 0
											}}
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-card-text>
					</v-card></v-tab-item
				>
			</v-tabs-items>
		</div>
		<div v-if="isDataLoading" class="overlay">
			<v-progress-circular
				:indeterminate="true"
			></v-progress-circular></div
	></v-container>
</template>

<script>
import { mapState } from "vuex";
import { FETCH_METRICS_DATA } from "../../store/action-types";
import { THEME_INPUT_COLOUR } from "../constants";
import { convertToReadableForm, keysFilteration } from "@/utils";
import EventsManager from "@/event-manager";

export default {
	name: "Metrics",
	data: () => ({
		convertToReadableForm: text => convertToReadableForm(text),
		keysFilteration: (keysArray, keysToBeFiltered) =>
			keysFilteration(keysArray, keysToBeFiltered),
		themeInputColor: THEME_INPUT_COLOUR,
		defaultData: { endDate: [], total: [] },
		totalData: { endDate: [], total: [] },
		isDataLoading: false,
		activeTab: "tab-0",
		tabs: [{ name: "MTD" }, { name: "Current Date" }],
		priorityKeys: [
			"gmv_offline_fantasy",
			"gmv_offline_rummy",
			"ludo_gmv_total"
		]
	}),
	mounted() {
		this.fetchMetricsData({ userId: this.userId });
		this.sendEvent("MTD");
	},
	methods: {
		fetchMetricsData(item) {
			if (this.isDataLoading) {
				return;
			}
			this.isDataLoading = true;
			const startDate = new Date().toISOString().slice(0, 8) + "01";
			const endDate = new Date().toISOString().slice(0, 10);
			this.$store
				.dispatch(FETCH_METRICS_DATA.dispatch, {
					userId: item.userId,
					startDate,
					endDate
				})
				.then(data => {
					const {
						aggregatable = this.defaultData,
						nonAggregatable = this.defaultData
					} = data.response;
					const aggregatableData = {
						...this.defaultData,
						...aggregatable
					};
					let mtdNonAggregatableData = {};
					let currentDateNonAggregatableData = {};
					Object.keys(nonAggregatable[0]).forEach(key => {
						if (key.startsWith("daily") || key.startsWith("dau")) {
							currentDateNonAggregatableData = {
								...currentDateNonAggregatableData,
								[key]: nonAggregatable[0][key]
							};
						} else if (
							key.startsWith("monthly") ||
							key.startsWith("mau")
						) {
							mtdNonAggregatableData = {
								...mtdNonAggregatableData,
								[key]: nonAggregatable[0][key]
							};
						}
					});
					this.totalData = {
						endDate: [
							{
								...aggregatableData.endDate[0],
								"gmv_excluding_7777_and_5500_%": `${Math.round(
									((aggregatableData.endDate[0]
										.gmv_excluding_7777_and_5550 || 0) /
										(aggregatableData.endDate[0]
											.gmv_offline_fantasy || Infinity)) *
										100 *
										100
								) / 100}%`,
								...currentDateNonAggregatableData
							}
						],
						total: [
							{
								...aggregatableData.total[0],
								"gmv_excluding_7777_and_5500_%": `${Math.round(
									((aggregatableData.total[0]
										.gmv_excluding_7777_and_5550 || 0) /
										(aggregatableData.total[0]
											.gmv_offline_fantasy || Infinity)) *
										100 *
										100
								) / 100}%`,
								...mtdNonAggregatableData
							}
						]
					};
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isDataLoading = false;
				});
		},
		sendEvent(type) {
			EventsManager.sendEvent({
				name: "METRICS_TAB_OPENED",
				properties: {
					userId: this.userId,
					type: this.storeType,
					actionTab: type
				}
			});
		}
	},
	computed: {
		...mapState({
			userId: state => state.auth.USERID,
			storeType: state => state.jeet11.jeet11PartnerDetails.userType
		})
	}
};
</script>
<style lang="scss" scoped>
.overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
}
</style>
